import type { SVGProps } from 'react';

const SvgSnapshot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 8h-.46l-1.11-1.66A3 3 0 0 0 13.93 5h-3.86c-1.01 0-1.94.5-2.5 1.34L6.46 8H6c-1.65 0-3 1.35-3 3v7c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-7c0-1.65-1.35-3-3-3m1 10c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h.46c.67 0 1.29-.33 1.66-.89l1.11-1.66c.19-.28.5-.45.83-.45h3.86c.34 0 .65.17.83.45l1.11 1.66c.37.56.99.89 1.66.89h.46c.55 0 1 .45 1 1v7z"
    />
    <path
      fill="currentcolor"
      d="M12 10c-1.93 0-3.5 1.57-3.5 3.5S10.07 17 12 17s3.5-1.57 3.5-3.5S13.93 10 12 10m0 5c-.83 0-1.5-.67-1.5-1.5S11.17 12 12 12s1.5.67 1.5 1.5S12.83 15 12 15"
    />
  </svg>
);
export default SvgSnapshot;
